<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Bill Settings'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-card>
      <form [formGroup]="form" novalidate action="#">
        <tidy-row>
          <tidy-text [body]="'Do you want to use TIDY for payments?'" />
        </tidy-row>
        <tidy-row>
          <tidy-radio-button
              [items]="[
                { value: true, viewValue: 'Yes' },
                { value: false, viewValue: 'No' }
              ]"
            formControlName="useTidyForPayments"
            [form]="form.controls.useTidyForPayments" />
        </tidy-row>
        @if (form.value.useTidyForPayments) {
          <tidy-row class="extra-top-padding">
            <tidy-text [body]="'Do you want to autopay?'" />
          </tidy-row>
          <tidy-row>
            <tidy-radio-button
                [items]="[
                  { value: true, viewValue: 'Yes' },
                  { value: false, viewValue: 'No' }
                ]"
              formControlName="autopay"
              [form]="form.controls.autopay" />
          </tidy-row>
        }
      </form>
    </tidy-card>

    <tidy-button
      [text]="'Save Bill Settings'"
      class="primary"
      [action]="boundSave" />
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
